export class NanolumensCaptivateBase {
    constructor(log) {
        this.log = log;
        this.power = false;
        this.brightness = 0;
        this.videoInput = 1; // hdmi1
        this.asyncHandlers = [
            {
                name: 'deviceStatus',
                regExp: /\x55{7}\xC0\x01\x03\x01\xD0\x00\xD1\x01\xc0\x00{2}\xff{17}/,
                callback: (match) => {
                    this.send(this.makeResponse([0x02, 0xc0], [0x01, 0x00]));
                },
            },
            {
                name: 'brightnessGet',
                regExp: /\x55{7}\xC0\x01\x03\x01\xD0\x00\xD1\x1d\xc2\x00\x00\xff{17}/,
                callback: (match) => {
                    // Driver sets brightness to 90 when on.
                    this.send(this.makeResponse([0x1e, 0xc2], [this.brightness]));
                },
            },
            {
                name: 'brightnessSet',
                regExp: /\x55{7}\xC0\x01\x03\x01\xD0\x00\xD1\x1f\xc2\x00\x00\xff{17}\x00\x01\x00([\S\s])[\S\s]/,
                callback: (match) => {
                    this.brightness = match[1].charCodeAt(0);
                    // All brightness set commands return the same value.
                    this.send(this.makeResponse([0x20, 0xc2], [0x01, 0x00]));
                },
            },
            {
                name: 'powerGet',
                regExp: /\x55{7}\xC0\x01\x03\x01\xD0\x00\xD1\x05\xc0\x00\x00\xff{17}/,
                callback: (match) => {
                    this.send(this.makeResponse([0x06, 0xc0], [this.power ? 0x80 : 0x00]));
                },
            },
            {
                name: 'powerSet',
                regExp: /\x55{7}\xC0\x01\x03\x01\xD0\x00\xD1\x03\xc0\x00\x00\xff{17}\x00\x01\x00([\S\s])[\S\s]/,
                callback: (match) => {
                    this.power = match[1].charCodeAt(0) === 0x5e;
                    this.send(this.makeResponse([0x04, 0xc0], [match[1].charCodeAt(0)]));
                },
            },
            {
                name: 'videoInputGet',
                regExp: /\x55{7}\xC0\x01\x03\x01\xD0\x00\xD1\x11\xc2\x00{2}\xff{17}/,
                callback: (match) => {
                    this.send(this.makeResponse([0x12, 0xc2], [this.videoInput]));
                },
            },
            {
                name: 'videoInputSet',
                regExp: /\x55{7}\xC0\x01\x03\x01\xD0\x00\xD1\x13\xc2\x00{2}\xff{17}\x00\x01\x00([\S\s])[\S\s]/,
                callback: (match) => {
                    this.videoInput = match[1].charCodeAt(0);
                    this.send(this.makeResponse([0x14, 0xc2], [0x01, 0x00]));
                },
            },
        ];
    }
    makeResponse(cmd, data) {
        const command = [
            0x55,
            0x55,
            0x55,
            0x55,
            0x55,
            0x55,
            0x55,
            0xc0,
            //--
            0x01,
            0x03,
            //--
            0x00,
            0xd1,
            //--
            0x01,
            0xd0,
            //--
            ...cmd,
            //--
            0x00,
            0x00,
            //--
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            //--
            0x00,
            //--
            data.length & 0xff,
            (data.length >> 8) & 0xff,
            //--
            ...data,
        ];
        let checksum = 0; // checksum from byte 8 on
        for (let i = 8; i < command.length; i++) {
            checksum += command[i];
        }
        command.push(checksum & 0x00ff);
        return command;
    }
    onConfigure(config) {
        var _a;
        let lowestCode;
        for (const videoInput of Object.values((_a = config.videoInputs) !== null && _a !== void 0 ? _a : {})) {
            const code = parseInt(videoInput === null || videoInput === void 0 ? void 0 : videoInput.code, 10);
            if (this.videoInput === code)
                return;
            if (lowestCode === undefined || code < lowestCode) {
                lowestCode = code;
            }
        }
        this.videoInput = lowestCode !== null && lowestCode !== void 0 ? lowestCode : 0;
    }
    commandExtractor(buffer) {
        const regExLength = 38;
        const cmdRegEx = /(\x55{7}\xc0\x01\x03\x01\xd0\x00\xd1[\S\s]{2}\x00{2}\xff{17}\x00)([\S\s]{2})/;
        if (buffer.length >= regExLength + 1) {
            for (let i = 0; i < buffer.length - regExLength; i++) {
                const cmdToTest = buffer.slice(i);
                const match = cmdRegEx.exec(cmdToTest);
                if (match && match[1]) {
                    const dataLength = match[2].charCodeAt(0);
                    const cmdLength = match[1].length + 2 + dataLength + 1; // includes checksum
                    const command = `${match[1]}${match[2]}${cmdToTest.slice(match[1].length + 2, cmdLength)}`;
                    buffer = buffer.slice(cmdLength + i);
                    return { command, buffer };
                }
            }
        }
        return undefined;
    }
}
